const ABProcessTaskServiceCalculateCore = require("../../../core/process/tasks/ABProcessTaskServiceCalculateCore");
module.exports = class ABProcessTaskServiceCalculate extends (
   ABProcessTaskServiceCalculateCore
) {};
